// components/admin/ProductQuickEdit.jsx
import React from "react";
import ImageSlotsPicker from "./ImageSlotsPicker";
import { API_BASE_URL } from "../../utils/constants";

export default function ProductQuickEdit({
  p,
  ui,
  setRowUiField,
  handleLocalChange,
  handleSave,
  savingId,
  toggleRowOpen,
  onDeleteExistingImage,
}) {
  const handlePick = (file) => {
    const next = [...(ui.pendingFiles || []), file].slice(0, 5);
    setRowUiField(p.id, "pendingFiles", next);
  };
  const handleRemovePending = (idx) => {
    const next = [...(ui.pendingFiles || [])];
    next.splice(idx, 1);
    setRowUiField(p.id, "pendingFiles", next);
  };

  const finishAndClose = () => {
    // tell the card to re-show Edit button
    ui?.onDone?.();
    // clear stored callback to avoid leaks
    setRowUiField(p.id, "onDone", null);
    // close the row
    toggleRowOpen(p.id);
  };

  const handleCancel = () => {
    finishAndClose();
  };

  const handleSaveClick = async () => {
    await handleSave(p);
    // collapse edit pane and tell the card to exit edit-mode
    try { toggleRowOpen(p.id, false); } catch {}
    try { ui?.done && ui.done(); } catch {}
    finishAndClose()
  };

  return (
    <div className="border-t p-4 bg-gray-50">
      <div className="grid grid-cols-1 gap-4">
        {/* Basic fields */}
        <div className="gap-4">
          {/* Subname */}
          <label className="flex flex-col text-sm mb-2">
            <span className="mb-1 text-gray-600">Subname</span>
            <input
              type="text"
              value={p.subname ?? ""}
              onChange={(e) => handleLocalChange(p.id, "subname", e.target.value)}
              className="rounded border px-3 py-2 bg-white"
              placeholder="Enter subname"
            />
          </label>

          {/* Sponsored toggle */}
          <label className="flex text-sm mb-2 items-center gap-3">
            <span className="text-gray-600">Sponsored</span>
            <input
              type="checkbox"
              checked={!!p.sponsored}
              onChange={(e) => handleLocalChange(p.id, "sponsored", e.target.checked)}
            />
          </label>

          {/* Description */}
          <label className="flex flex-col text-sm md:col-span-2">
            <span className="mb-1 text-gray-600">Description</span>
            <textarea
              value={p.description ?? ""}
              onChange={(e) => handleLocalChange(p.id, "description", e.target.value)}
              rows={5}
              className="rounded border px-3 py-2 bg-white resize-y"
              placeholder="Enter product description…"
            />
          </label>
        </div>

        {/* Image slots (max 5) */}
        <div className="text-sm">
          <div className="flex items-center justify-between mb-2">
            <span className="block text-gray-600">Images (max 5)</span>
            <span className="text-xs text-gray-500">
              {(p.images?.length || 0) + (ui.pendingFiles?.length || 0)} / 5
            </span>
          </div>

          <ImageSlotsPicker
            existingImages={p.images || []}
            pendingFiles={ui.pendingFiles || []}
            onPick={handlePick}
            onRemovePending={handleRemovePending}
            onRemoveExisting={(img) => onDeleteExistingImage(p.id, img)}
            uploadsBase={`${API_BASE_URL}/uploads`}
          />

          <p className="mt-2 text-xs text-gray-500">
            Click a slot to add one image (40×40px). Use × to remove. Removing an existing image deletes it from the database.
          </p>
        </div>

        <div className="flex items-center justify-end gap-2">
          <button className="px-4 py-2 rounded border" onClick={handleCancel}>
            Cancel
          </button>
          <button
            className="bg-black text-white px-4 py-2 rounded disabled:opacity-60"
            disabled={savingId === p.id}
            onClick={handleSaveClick}
          >
            {savingId === p.id ? "Saving…" : "Save changes"}
          </button>
        </div>
      </div>
    </div>
  );
}
